<template>
  <forgerock-template id="passkey-page" container-class="container" :showFooter="false">
    <stihl-section>
      <h1>{{ title }}</h1>
      <span>{{ $t('SUI.page.passkey.waiting')}}</span>
    </stihl-section>
  </forgerock-template>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'pinia';
import { useLoginStore } from '@/components/login.store';
import { CallbackType, FRStep, FRWebAuthn, WebAuthnStepType } from '@forgerock/javascript-sdk';
import { fr } from '@/components/forgerock';
import ForgerockTemplate from '@/components/layout/ForgerockTemplate.vue';
import StihlSection from '@/components/ui/StihlSection.vue';

export default defineComponent({
  name: 'PasskeyPage',
  components: { StihlSection, ForgerockTemplate },

  data() {
    return {
      state: '',
    };
  },

  computed: {
    ...mapState(useLoginStore, ['currentStep', 'locale']),
    title() {
      if (this.state === 'register') {
        return this.$t('SUI.page.passkey.register.title');
      }
      if (this.state === 'auth') {
        return this.$t('SUI.page.passkey.auth.title');
      }
      return '';
    },
  },

  async mounted() {
    console.debug('[SUI::Passkey]');

    let step: FRStep = this.currentStep;

    const stepType = FRWebAuthn.getWebAuthnStepType(this.currentStep);
    if (stepType === WebAuthnStepType.None) {
      console.error('[SUI::Passkey] unexpected step type', step);
      this.$router.push('/error');
      return;
    }

    // Authenticate with a registered device
    try {

      if (stepType === WebAuthnStepType.Registration) {
        this.state = 'register';
        step = await FRWebAuthn.register(this.currentStep);
        console.debug('[SUI::Passkey] reg nextStep', step);

      } else if (stepType === WebAuthnStepType.Authentication) {
        this.state = 'auth';
        step = await FRWebAuthn.authenticate(this.currentStep);
        console.debug('[SUI::Passkey] auth nextStep', step);
      }

    } catch (e: unknown) {
      if (!(e instanceof Error)) throw e;

      console.info('[SUI::Passkey] webauthn error:', e.name, e.message);
      step.getCallbackOfType(CallbackType.HiddenValueCallback).setInputValue(`ERROR::${e.name}: ${e.message}`);
    }

    fr.submitStep(step);
  },
});
</script>

<style scoped>
* {
  background-color: #F37A1F;
}
</style>
